export const ENV = {
  PRODUCTION: false,
  NAME: "staging",
  CAS: {
    DOMAIN: 'https://casi.cwsfirabarcelona.com/login',
    CSS_URL: 'https://stg-mediarepository.cwsfirabarcelona.com/shows/backoffice/css/cas.css',
    LANG: 'es',
    SERVICE: '/login',
    LOGOUT: 'https://casi.cwsfirabarcelona.com/logout'
  },
  APP: {
    FRONTEND_URL: 'https://contractorpassstg-backoffice.cwsfirabarcelona.com',
    BACKEND_API: ' https://contractorpassstg-api.cwsfirabarcelona.com/v1',
    FRONTOFFICE_URL: 'https://contractorpassstg.cwsfirabarcelona.com'
  },
  BASE_PATH: {
    USERS: 'https://usersi.cwsfirabarcelona.com/v1',
    EVENT: 'https://eventstg.cwsfirabarcelona.com/v1'
  },
  MOCKS: false,
  MOCKS_BASE_PATH: 'http://localhost:3000',
  // MEDIA_REPOSITORY: 'https://stg-mediarepository.cwsfirabarcelona.com/recoverypassword/translations'
};
